import { HiPaperClip } from "react-icons/hi2";

export const PaperClipIcon = (props) => (
  <HiPaperClip size={24} {...props} />
);
